var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loading"},[(_vm.message)?_c('h1',[_vm._v(_vm._s(_vm.message))]):_c('h1',[_vm._v(_vm._s(_vm.$t('global.loading_text')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }